import { render, staticRenderFns } from "./filters.component.vue?vue&type=template&id=61437a3b&scoped=true"
import script from "./filters.component.vue?vue&type=script&lang=ts"
export * from "./filters.component.vue?vue&type=script&lang=ts"
import style0 from "./filters.component.vue?vue&type=style&index=0&id=61437a3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61437a3b",
  null
  
)

export default component.exports